module.exports = __webpack_public_path__ + "img/information (2).b6b650f8.svg";